<!-- eslint-disable no-unused-vars -->
<template>
  <header>
    <nav class="main-header navbar navbar-expand fixed-top">
      <div class="container-fluid">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link" @click="toggleAside" data-widget="pushmenu" href="#" role="button" id="NavIcon"><i
                class="fas fa-bars"></i></a>
          </li>
        </ul>
        <ul class="navbar-nav me-auto notifactions">
          <li class="nav-item dropdown">
            <button class="nav-link" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown"
              aria-expanded="false">
              <i class="far fa-bell"></i>
              <span class="badge badge-danger navbar-badge">{{
                isReadCount
              }}</span>
            </button>
            <ul class="dropdown-menu notifications_list" aria-labelledby="dropdownMenuButton1"
              v-if="notifications.length != 0">
              <li v-for="(item, index) in notifications" :key="index" class="dropdown-item" :class="{
                notification_active: !item.is_read,
              }">
                <router-link :to="this.redirectLink(item.path)" class="notification_item nav-link"
                  @click.prevent="changeRead(item.id)">
                  <div class="notification_content">
                    <h5>{{ item.title }}</h5>
                    <p v-html="generateContent(item)"></p>
                  </div>
                </router-link>
              </li>
              <li v-if="count > 6 && count !== notifications.length" class="dropdown-item">
                <a class="btn btn-dark w-100" type="button" role="button" @click.prevent="loadMore">تحميل المزيد</a>
              </li>
            </ul>
            <ul class="dropdown-menu notifications_list" aria-labelledby="dropdownMenuButton1" v-else>
              <li class="nodata">لا توجد اشعارات حتى الان</li>
            </ul>
          </li>
        </ul>
        <!-- <ul class="navbar-nav me-auto notifactions">
          <li class="nav-item dropdown">
            <button class="nav-link" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
              <i class="far fa-comments"></i>
              <span class="badge badge-danger navbar-badge">3</span>
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li><a class="dropdown-item" href="#"></a></li>
            </ul>
          </li>
        </ul> -->
        <ul class="navbar-nav ms-auto">
          <li class="nav-item">
            <button
              class="theme-toggle"
              type="button"
              :title="isDark ? 'الوضع النهاري' : 'الوضع الليلي'"
              :aria-label="isDark ? 'الوضع النهاري' : 'الوضع الليلي'"
              @click="toggleTheme"
            >
              <i :class="isDark ? 'fas fa-sun' : 'fas fa-moon'"></i>
            </button>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

const THEME_STORAGE_KEY = "admin-panel-theme";

export default {
  props: ["currentView"],
  data() {
    return {
      // null = follow the OS preference.
      theme: null,
    };
  },
  methods: {
    ...mapActions("notificationModule", ["getAllNotifications"]),
    ...mapActions("ViewVideoModule", ["updateNotification"]),
    toggleAside() {
      document.body.classList.toggle("aside-collapsed");
    },

    // Writes data-theme on <html>; the SCSS tokens key off it and off
    // prefers-color-scheme, so an explicit choice always wins.
    applyTheme(theme) {
      const root = document.documentElement;
      if (theme === "dark" || theme === "light") {
        root.setAttribute("data-theme", theme);
      } else {
        root.removeAttribute("data-theme");
      }
    },

    toggleTheme() {
      this.theme = this.isDark ? "light" : "dark";
      this.applyTheme(this.theme);
      try {
        localStorage.setItem(THEME_STORAGE_KEY, this.theme);
      } catch (error) {
        // Private browsing can block storage; the toggle still works for the
        // current page.
        console.warn("Could not persist the theme choice", error);
      }
    },

    prefersDark() {
      return (
        typeof window.matchMedia === "function" &&
        window.matchMedia("(prefers-color-scheme: dark)").matches
      );
    },
    generateContent(item) {
      // eslint-disable-next-line no-unused-vars

      const { tags, body, keys } = item;
      return body.replace(
        new RegExp(`${Object.keys(tags).join("|")}`, "g"),
        (e) => {
          return `<span class="text-info">${keys[tags[e]]}</span>`;
        }
      );
    },
    async loadMore() {
      await this.getAllNotifications(this.getUser.uid);
    },
    async changeRead(id) {
      await this.updateNotification(id);
    },
    redirectLink(link) {
      let validLink = "lessons/view_lesson" + link.replace("/admin", "");
      return validLink;
    },
  },
  computed: {
    isDark() {
      return this.theme ? this.theme === "dark" : this.prefersDark();
    },
    ...mapGetters("notificationModule", [
      "notifications",
      "count",
      "isReadCount",
    ]),
    ...mapGetters("adminModule", ["getUser"]),
  },
  created() {
    let stored = null;
    try {
      stored = localStorage.getItem(THEME_STORAGE_KEY);
    } catch (error) {
      console.warn("Could not read the stored theme", error);
    }
    this.theme = stored === "dark" || stored === "light" ? stored : null;
    this.applyTheme(this.theme);
  },
};
</script>

<style lang="scss" scopped>
@import "../scss/abstracts/_variables.scss";

header {
  background-color: var(--topbar-bg);
  margin-right: var(--aside-width);
  align-items: center;
  border-bottom: 1px solid var(--topbar-border);
  transition: background-color var(--transition), border-color var(--transition),
    margin var(--transition-slow);
  z-index: 1;

  .navbar {
    padding: 0;
  }

  .navbar-nav {
    padding-right: 0;

    .nav-item {
      .nav-link {
        font-size: var(--h3-font-size);
        font-weight: bold;
        padding: 0.5rem 1rem;
        color: var(--aside-color);

        &:hover {
          color: var(--main-color);
        }
      }
    }

    &.notifactions {
      button {
        all: unset;
        color: var(--text-muted);
        padding-right: 1rem;
        padding-left: 1rem;
        padding: 0.5rem 1rem;
        transition: all 0.4s ease-in-out;
        cursor: pointer;

        &:hover {
          color: var(--main-color);
        }

        .navbar-badge {
          font-size: 0.6rem;
          font-weight: 300;
          padding: 2px 4px;
          position: absolute;
          right: 5px;
          top: 9px;
        }

        .badge-danger {
          color: #fff;
          background-color: var(--danger);
        }
      }
    }
  }
}

.notifications_list {
  padding: 0px 20px !important;
  max-height: 35rem;
  margin: 0px;
  overflow-y: auto;
  max-width: 20rem;
  width: calc(100vw - 1rem);

  &.dropdown-menu {
    border: 1px solid var(--border-subtle);
    box-shadow: var(--shadow-lg);
    position: relative;
    max-height: 85vh;

    &::-webkit-scrollbar {
      width: 7px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
      border-radius: var(--radius-pill);
    }

    &::-webkit-scrollbar-thumb {
      background-color: var(--border);
      border-radius: var(--radius-pill);
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: var(--border-strong);
    }
  }

  li {
    padding: 15px;

    &:not(:last-child) {
      border-bottom: 1px solid var(--border-subtle);
    }

    &:last-child:hover {
      background-color: var(--bg-surface);
    }
  }

  .notification {
    &_item {
      padding-block: 5px;
    }

    &_active {
      background-color: var(--bg-active);
    }

    &_body {
      display: flex;
      align-items: center;
      gap: 20px;
    }

    &_icon {
      width: 45px;
      height: 45px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: var(--bg-hover);
      border-radius: var(--radius-xs);

      i {
        color: var(--text-muted);
        font-size: 14px;
      }
    }

    &_content {
      white-space: normal;

      h5 {
        font-size: 14px;
        font-weight: 500;
        color: var(--text-primary);
        margin-bottom: 3px;
      }

      p {
        font-size: 12px;
        font-weight: 600;
        color: var(--text-secondary);
        margin-top: 5px !important;
        margin-bottom: 0px;
      }
    }
  }

  .nodata {
    text-align: center;
    font-weight: bold;
    font-size: 14px;
  }
}
</style>
